<template lang="pug">
Card.selections-card
    template(#header)
        .title {{ $t('selections.ukCountry.title') }}
    template(#content)
      .country-control
        SelectionsButtons.selector(:items="items" v-model="countryCode")

</template>
<script lang="ts">
import { useSelections } from "@/store/selections";
import { defineComponent } from "vue";
import { storeToRefs } from "pinia";
import Card from "primevue/card";
import SelectionsButtons from "@/components/forms/components/SelectionsButtons.vue";
import { UKCountryCode } from "@/types";
import { t } from "@/helpers/locale";

export default defineComponent({
  name: "CountrySelector",
  components: {
    Card,
    SelectionsButtons,
  },
  setup() {
    const selections = useSelections();
    const { countryCode } = storeToRefs(selections);

    type KeyType = keyof typeof UKCountryCode;

    const items = Object.keys(UKCountryCode).map((key) => ({
      label: t("selections.ukCountry." + UKCountryCode[key as KeyType]),
      value: UKCountryCode[key as KeyType],
    }));

    return {
      countryCode,
      items,
    };
  },
});
</script>
<style scoped lang="scss">
@media screen and (max-width: 640px) {
  .selector {
    :deep(.form-control-buttons) {
      flex-direction: column;
      button {
        flex-basis: auto;
      }
    }
  }
}
</style>
